import { ItemT, RawItemT } from '../models/cart'

export function getFilteredCartItems (items: RawItemT[]) {
  return items.filter(({ itemType }: { itemType: number }) => isDeliveryType(itemType)).map(({ id, displayName, unitPrice, customizationMenuItems, quantity, totalPrice }: {
    id: string,
    displayName: string,
    unitPrice: number,
    customizationMenuItems: Array<any>
    quantity: number
    totalPrice: number,
  }) => ({
    id,
    name: displayName,
    price: unitPrice / 100,
    totalPrice: totalPrice / 100,
    quantity,
    customizationMenuItems: customizationMenuItems.map(cmi => ({
      ...cmi,
      price: cmi.price / 100,
      takeAwayPrice: cmi.takeAwayPrice ? cmi.takeAwayPrice / 100 : undefined
    })),
  })) as ItemT[]
}

function isDeliveryType (itemType: number) {
  const deliveryTypes = [400, 500, 600, 700]
  return !deliveryTypes.includes(itemType)
}

export function getTotalPrice (items: ItemT[]) {
  return items.reduce((prev: number, current: ItemT) => {
    return prev + current.totalPrice
  }, 0)
}
